import { FC } from 'react'

import { ContactAvatar, ContactAvatarType } from './Avatar'

export const Contact: FC & ContactAvatarType = (): JSX.Element => <></>

Contact.Avatar = ContactAvatar
